module.exports = __webpack_public_path__ + "assets/img/icon11.ca8513bf.png";